export default function IconChevronUp(props) {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <polyline points="18 15 12 9 6 15"/>
    </svg>
  )
}
